/**
 * @fileoverview gRPC-Web generated client stub for acompanha.printer_maintenances.v1
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v4.25.2
// source: acompanha/printer_maintenances/v1/printer_maintenances.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var acompanha_common_v1_common_pb = require('../../../acompanha/common/v1/common_pb.js')

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')
const proto = {};
proto.acompanha = {};
proto.acompanha.printer_maintenances = {};
proto.acompanha.printer_maintenances.v1 = require('./printer_maintenances_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.acompanha.printer_maintenances.v1.PrinterMaintenancesServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.acompanha.printer_maintenances.v1.PrinterMaintenancesServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.printer_maintenances.v1.ListMaintenancesRequest,
 *   !proto.acompanha.printer_maintenances.v1.ListMaintenancesResponse>}
 */
const methodDescriptor_PrinterMaintenancesService_ListMaintenances = new grpc.web.MethodDescriptor(
  '/acompanha.printer_maintenances.v1.PrinterMaintenancesService/ListMaintenances',
  grpc.web.MethodType.UNARY,
  proto.acompanha.printer_maintenances.v1.ListMaintenancesRequest,
  proto.acompanha.printer_maintenances.v1.ListMaintenancesResponse,
  /**
   * @param {!proto.acompanha.printer_maintenances.v1.ListMaintenancesRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.printer_maintenances.v1.ListMaintenancesResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.printer_maintenances.v1.ListMaintenancesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.printer_maintenances.v1.ListMaintenancesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.printer_maintenances.v1.ListMaintenancesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.printer_maintenances.v1.PrinterMaintenancesServiceClient.prototype.listMaintenances =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.printer_maintenances.v1.PrinterMaintenancesService/ListMaintenances',
      request,
      metadata || {},
      methodDescriptor_PrinterMaintenancesService_ListMaintenances,
      callback);
};


/**
 * @param {!proto.acompanha.printer_maintenances.v1.ListMaintenancesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.printer_maintenances.v1.ListMaintenancesResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.printer_maintenances.v1.PrinterMaintenancesServicePromiseClient.prototype.listMaintenances =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.printer_maintenances.v1.PrinterMaintenancesService/ListMaintenances',
      request,
      metadata || {},
      methodDescriptor_PrinterMaintenancesService_ListMaintenances);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.printer_maintenances.v1.GetMaintenanceRequest,
 *   !proto.acompanha.printer_maintenances.v1.GetMaintenanceResponse>}
 */
const methodDescriptor_PrinterMaintenancesService_GetMaintenance = new grpc.web.MethodDescriptor(
  '/acompanha.printer_maintenances.v1.PrinterMaintenancesService/GetMaintenance',
  grpc.web.MethodType.UNARY,
  proto.acompanha.printer_maintenances.v1.GetMaintenanceRequest,
  proto.acompanha.printer_maintenances.v1.GetMaintenanceResponse,
  /**
   * @param {!proto.acompanha.printer_maintenances.v1.GetMaintenanceRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.printer_maintenances.v1.GetMaintenanceResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.printer_maintenances.v1.GetMaintenanceRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.printer_maintenances.v1.GetMaintenanceResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.printer_maintenances.v1.GetMaintenanceResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.printer_maintenances.v1.PrinterMaintenancesServiceClient.prototype.getMaintenance =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.printer_maintenances.v1.PrinterMaintenancesService/GetMaintenance',
      request,
      metadata || {},
      methodDescriptor_PrinterMaintenancesService_GetMaintenance,
      callback);
};


/**
 * @param {!proto.acompanha.printer_maintenances.v1.GetMaintenanceRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.printer_maintenances.v1.GetMaintenanceResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.printer_maintenances.v1.PrinterMaintenancesServicePromiseClient.prototype.getMaintenance =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.printer_maintenances.v1.PrinterMaintenancesService/GetMaintenance',
      request,
      metadata || {},
      methodDescriptor_PrinterMaintenancesService_GetMaintenance);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.printer_maintenances.v1.CreateMaintenanceRequest,
 *   !proto.acompanha.printer_maintenances.v1.CreateMaintenanceResponse>}
 */
const methodDescriptor_PrinterMaintenancesService_CreateMaintenance = new grpc.web.MethodDescriptor(
  '/acompanha.printer_maintenances.v1.PrinterMaintenancesService/CreateMaintenance',
  grpc.web.MethodType.UNARY,
  proto.acompanha.printer_maintenances.v1.CreateMaintenanceRequest,
  proto.acompanha.printer_maintenances.v1.CreateMaintenanceResponse,
  /**
   * @param {!proto.acompanha.printer_maintenances.v1.CreateMaintenanceRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.printer_maintenances.v1.CreateMaintenanceResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.printer_maintenances.v1.CreateMaintenanceRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.printer_maintenances.v1.CreateMaintenanceResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.printer_maintenances.v1.CreateMaintenanceResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.printer_maintenances.v1.PrinterMaintenancesServiceClient.prototype.createMaintenance =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.printer_maintenances.v1.PrinterMaintenancesService/CreateMaintenance',
      request,
      metadata || {},
      methodDescriptor_PrinterMaintenancesService_CreateMaintenance,
      callback);
};


/**
 * @param {!proto.acompanha.printer_maintenances.v1.CreateMaintenanceRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.printer_maintenances.v1.CreateMaintenanceResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.printer_maintenances.v1.PrinterMaintenancesServicePromiseClient.prototype.createMaintenance =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.printer_maintenances.v1.PrinterMaintenancesService/CreateMaintenance',
      request,
      metadata || {},
      methodDescriptor_PrinterMaintenancesService_CreateMaintenance);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.printer_maintenances.v1.UpdateMaintenanceRequest,
 *   !proto.acompanha.printer_maintenances.v1.UpdateMaintenanceResponse>}
 */
const methodDescriptor_PrinterMaintenancesService_UpdateMaintenance = new grpc.web.MethodDescriptor(
  '/acompanha.printer_maintenances.v1.PrinterMaintenancesService/UpdateMaintenance',
  grpc.web.MethodType.UNARY,
  proto.acompanha.printer_maintenances.v1.UpdateMaintenanceRequest,
  proto.acompanha.printer_maintenances.v1.UpdateMaintenanceResponse,
  /**
   * @param {!proto.acompanha.printer_maintenances.v1.UpdateMaintenanceRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.printer_maintenances.v1.UpdateMaintenanceResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.printer_maintenances.v1.UpdateMaintenanceRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.printer_maintenances.v1.UpdateMaintenanceResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.printer_maintenances.v1.UpdateMaintenanceResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.printer_maintenances.v1.PrinterMaintenancesServiceClient.prototype.updateMaintenance =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.printer_maintenances.v1.PrinterMaintenancesService/UpdateMaintenance',
      request,
      metadata || {},
      methodDescriptor_PrinterMaintenancesService_UpdateMaintenance,
      callback);
};


/**
 * @param {!proto.acompanha.printer_maintenances.v1.UpdateMaintenanceRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.printer_maintenances.v1.UpdateMaintenanceResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.printer_maintenances.v1.PrinterMaintenancesServicePromiseClient.prototype.updateMaintenance =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.printer_maintenances.v1.PrinterMaintenancesService/UpdateMaintenance',
      request,
      metadata || {},
      methodDescriptor_PrinterMaintenancesService_UpdateMaintenance);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.printer_maintenances.v1.DeleteMaintenanceRequest,
 *   !proto.acompanha.common.v1.SuccessResponse>}
 */
const methodDescriptor_PrinterMaintenancesService_DeleteMaintenance = new grpc.web.MethodDescriptor(
  '/acompanha.printer_maintenances.v1.PrinterMaintenancesService/DeleteMaintenance',
  grpc.web.MethodType.UNARY,
  proto.acompanha.printer_maintenances.v1.DeleteMaintenanceRequest,
  acompanha_common_v1_common_pb.SuccessResponse,
  /**
   * @param {!proto.acompanha.printer_maintenances.v1.DeleteMaintenanceRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  acompanha_common_v1_common_pb.SuccessResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.printer_maintenances.v1.DeleteMaintenanceRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.common.v1.SuccessResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.common.v1.SuccessResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.printer_maintenances.v1.PrinterMaintenancesServiceClient.prototype.deleteMaintenance =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.printer_maintenances.v1.PrinterMaintenancesService/DeleteMaintenance',
      request,
      metadata || {},
      methodDescriptor_PrinterMaintenancesService_DeleteMaintenance,
      callback);
};


/**
 * @param {!proto.acompanha.printer_maintenances.v1.DeleteMaintenanceRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.common.v1.SuccessResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.printer_maintenances.v1.PrinterMaintenancesServicePromiseClient.prototype.deleteMaintenance =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.printer_maintenances.v1.PrinterMaintenancesService/DeleteMaintenance',
      request,
      metadata || {},
      methodDescriptor_PrinterMaintenancesService_DeleteMaintenance);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.printer_maintenances.v1.ListMaintenancesByPrinterRequest,
 *   !proto.acompanha.printer_maintenances.v1.ListMaintenancesResponse>}
 */
const methodDescriptor_PrinterMaintenancesService_ListMaintenancesByPrinter = new grpc.web.MethodDescriptor(
  '/acompanha.printer_maintenances.v1.PrinterMaintenancesService/ListMaintenancesByPrinter',
  grpc.web.MethodType.UNARY,
  proto.acompanha.printer_maintenances.v1.ListMaintenancesByPrinterRequest,
  proto.acompanha.printer_maintenances.v1.ListMaintenancesResponse,
  /**
   * @param {!proto.acompanha.printer_maintenances.v1.ListMaintenancesByPrinterRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.printer_maintenances.v1.ListMaintenancesResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.printer_maintenances.v1.ListMaintenancesByPrinterRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.printer_maintenances.v1.ListMaintenancesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.printer_maintenances.v1.ListMaintenancesResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.printer_maintenances.v1.PrinterMaintenancesServiceClient.prototype.listMaintenancesByPrinter =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.printer_maintenances.v1.PrinterMaintenancesService/ListMaintenancesByPrinter',
      request,
      metadata || {},
      methodDescriptor_PrinterMaintenancesService_ListMaintenancesByPrinter,
      callback);
};


/**
 * @param {!proto.acompanha.printer_maintenances.v1.ListMaintenancesByPrinterRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.printer_maintenances.v1.ListMaintenancesResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.printer_maintenances.v1.PrinterMaintenancesServicePromiseClient.prototype.listMaintenancesByPrinter =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.printer_maintenances.v1.PrinterMaintenancesService/ListMaintenancesByPrinter',
      request,
      metadata || {},
      methodDescriptor_PrinterMaintenancesService_ListMaintenancesByPrinter);
};


module.exports = proto.acompanha.printer_maintenances.v1;

